import { createAsyncReducer } from '../../standard-actions/';
import {
    ISubmitEnquiryAction,
    ISubmitEnquirySuccessAction,
    SubmitEnquiryErrorAction
} from '../actions/submit-enquiry';
import { IChannelCareState } from '../state';
import { initialState } from '../state/initial-state';

export type SubmitEnquiryAction
    = ISubmitEnquiryAction
    | ISubmitEnquirySuccessAction
    | SubmitEnquiryErrorAction;

const init = (state: IChannelCareState, action: SubmitEnquiryAction) => ({
    ...state,
    submitEnquiry: {
        ...state.submitEnquiry,
        status: action.status
    }
});

const success = (state: IChannelCareState, action: SubmitEnquiryAction) => ({
    ...state,
    submitEnquiry: {
        ...initialState.submitEnquiry,
        status: action.status,
        data: (action as ISubmitEnquirySuccessAction).data
    }
});

const reset = (state: IChannelCareState, action: SubmitEnquiryAction) => ({
    ...state,
    submitEnquiry: {
        ...initialState.submitEnquiry,
        status: action.status,
        data: (action as ISubmitEnquirySuccessAction).data
    }
});

const failure = (state: IChannelCareState, action: SubmitEnquiryAction) => ({
    ...state,
    submitEnquiry: {
        ...initialState.submitEnquiry,
        status: action.status,
        error: (action as SubmitEnquiryErrorAction).error
    }
});

export const submitEnquiryReducer = createAsyncReducer(initialState, init, success, failure, reset);
